/**
 * The TextFieldType class is an enumeration of constant values used in setting the
 * <code>type</code> property of the TextField class.
 *
 * @see away.entities.TextField#type
 */
var TextFieldType = /** @class */ (function () {
    function TextFieldType() {
    }
    /**
     * Used to specify a <code>dynamic</code> TextField.
     */
    TextFieldType.DYNAMIC = 'dynamic';
    /**
     * Used to specify an <code>input</code> TextField.
     */
    TextFieldType.INPUT = 'input';
    /**
     * Used to specify an <code>static</code> TextField.
     */
    TextFieldType.STATIC = 'input';
    return TextFieldType;
}());
export { TextFieldType };
